import {
    RESOLVE_REDIRECT_SUCCESS,
    RESOLVE_SLUG,
    RESOLVE_SLUG_ERROR,
    RESOLVE_SLUG_SUCCESS,
} from "core-web/state/models/Page/constants";

import Events from "core-web/libs/Events";
import { PageEvents } from "core-web/libs/Events/constants";
import { ResolveSlug } from "core-web/libs/GrebbCommerceAPI/Content";
import { acquireMutex } from "core-web/state";
import getProductByPartNo from "./getProductByPartNo";
import getQueryParams from "core-web/utils/getQueryParams";
import handleProductData from "./handleProductData";
import { inServer } from "core-web/constants";
import store from "core-web/state/store";

export const resolveSlug = (slug, location) => async (dispatch, getState) => {
    const { applicationId, locale, path, origin } = getState().application;
    const mutexLock = await acquireMutex("page.resolveSlug");

    if (!applicationId) {
        return null;
    }

    dispatch({ type: RESOLVE_SLUG });

    try {
        const { p: selectedPartNoParameter } = getQueryParams(location) || {};
        const selectedPartNoState = location.state?.presetPartNo;
        const parameters = {};
        if (selectedPartNoState || selectedPartNoParameter) {
            parameters["selected_variant_part_no"] = selectedPartNoState || selectedPartNoParameter;
        }

        const response = await ResolveSlug(applicationId, slug, parameters, null, locale, path, origin);

        const type = response.data.type;

        if (type === "redirect") {
            dispatch({
                type: RESOLVE_REDIRECT_SUCCESS,
                pageData: {
                    to: response.data.to,
                    status: response.data.status,
                },
                pageType: type,
            });

            mutexLock();

            return;
        }

        const alternates = response.data.alternate || [];
        const cmsLocalizations = response.data.data?.localizations;
        if (cmsLocalizations && (!alternates?.length || alternates?.length <= 1)) {
            Object.keys(cmsLocalizations).forEach((locale) => {
                const permalink = cmsLocalizations[locale].permalink;
                const postId = cmsLocalizations[locale].id;
                const localeAlternate = {
                    external_id: postId,
                    locale,
                    slug: permalink,
                };

                alternates.push(localeAlternate);
            });
        }

        dispatch({
            type: RESOLVE_SLUG_SUCCESS,
            localeAlternates: alternates,
            pageData: response.data.data,
            pageType: type,
            pageTemplate: response.data.template,
            pageRelationships: response.data.relationships,
            pageSearch: location.search,
        });

        if (!inServer) {
            Events.trigger(PageEvents.RESET);
            Events.trigger(PageEvents.VIEW, {
                application: getState().application,
                page: getState().page,
            });
        }

        // Fetch product data
        if (type === "product") {
            let partNo = response.data.data.part_no || null;
            if (response.data.data.variant_part_nos.length > 0) {
                if (selectedPartNoState && response.data.data.variant_part_nos.includes(selectedPartNoParameter)) {
                    partNo = selectedPartNoState;
                } else if (
                    selectedPartNoParameter &&
                    response.data.data.variant_part_nos.includes(selectedPartNoParameter)
                ) {
                    partNo = selectedPartNoParameter;
                } else {
                    partNo = response.data.data.variant_part_nos[0];
                }
            }
            const productData = response.data.product_data;
            if (partNo && productData) {
                await handleProductData(partNo, productData, location);
            } else if (partNo) {
                await getProductByPartNo(partNo);
            }
        }

        mutexLock();
        return response;
    } catch (e) {
        dispatch({ type: RESOLVE_SLUG_ERROR });
    }

    mutexLock();
};

export default (slug, location) => store.dispatch(resolveSlug(slug, location));
